import {
  Component,
  DestroyRef,
  ElementRef,
  OnInit,
  ViewChild,
  inject,
  signal,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormGroupDirective,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import {
  Building,
  Coordinates,
  Floor,
  Parameter,
  User,
  Workplace,
} from '../../../models';
import {
  BuildingService,
  ReservationService,
  WorkplaceService,
} from '../../../services';
import { MatDialog } from '@angular/material/dialog';
import {
  ErrorStateMatcher,
  MatNativeDateModule,
  MatOptionModule,
} from '@angular/material/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WorkplaceTypeService } from '../../../services';
import { TypeOfJob } from '../../../models';
import { ParameterService } from '../../../services';
import { FloorService } from '../../../services';
import { customFormatDate, customNoFormatDate } from '@core/helpers';
import { customFullDate } from '@core/helpers/custom-full-date';
import { ToastAlertService } from '@core/services';
import { ButtonComponent } from '@shared/components/button/button.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { NgFor, NgIf } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { TitleComponent } from '@shared/components/title/title.component';
import { MatCardModule } from '@angular/material/card';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { BussinesService } from '@public/services';
import { BusyWorkplace } from '@admin/models/busyWorkplace';
import { PinchZoomModule } from '@meddv/ngx-pinch-zoom';
export class ReservationError implements ErrorStateMatcher {
  isErrorState(
    control: FormGroup | null,
    form: FormGroupDirective | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}
@Component({
  templateUrl: './create-reservations-page.component.html',
  styles: [],
  standalone: true,
  imports: [
    MatCardModule,
    TitleComponent,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    NgFor,
    MatOptionModule,
    MatInputModule,
    MatDatepickerModule,
    NgIf,
    MatCheckboxModule,
    ButtonComponent,
    MatNativeDateModule,
    MatAutocompleteModule,
    PinchZoomModule,
  ],
})
export class CreateReservationsPageComponent implements OnInit {
  isLoading = false;
  dataMap = '';
  @ViewChild('canvas') canvas!: ElementRef; // ViewChild para obtener una referencia al elemento canvas en el componente
  workplace: Workplace[] = [];
  busyWorkplace: BusyWorkplace[] = [];
  co: Coordinates[] = [];
  private floorService = inject(FloorService);
  formCreated!: FormGroup;
  selectedDate?: Date;
  duration!: string;
  workplaces: boolean = false;
  body!: any;

  private typeId = signal(0);
  private floorId = signal(0);
  private startDate = signal('');
  private endDate = signal('');
  private noFormatDate = signal('');

  public isActiveSearch = false;
  public available = signal<any>(null);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  private dialog = inject(MatDialog);

  showButtonReservation: boolean = false;
  private buildingService = inject(BuildingService);
  public matcher = new ReservationError();
  private destroyRef = inject(DestroyRef);
  private workplaceService = inject(WorkplaceService);
  private reservationsService = inject(ReservationService);
  private alertService = inject(ToastAlertService);
  private bussinesService = inject(BussinesService);
  #workPLaceTypeService = inject(WorkplaceTypeService);

  groups: Building[] = [];
  isNormal: string = '1';

  // para seleccionar los items
  disableSelect = new FormControl(false);

  private formBuilder = inject(FormBuilder);
  // private reservationService=inject(ReservationService)
  disabledFormDate: boolean;

  // Restringir fecha
  public ahora?: Date;
  // Hora
  horarios: string[] = [
    '08:00',
    '09:00',
    '10:00',
    '11:00',
    '12:00',
    '13:00',
    '14:00',
    '15:00',
    '16:00',
  ];

  horariosFiltrados: string[] = [];

  dataSource: MatTableDataSource<Building>;
  selectedHour: number = 0;
  selectedMinute: number = 0;
  availableHours = signal<string[]>([]);
  availableMinutes: number[] = [];

  puestos: TypeOfJob[] = [];
  edificios: Building[] = [];

  minDate: Date;

  constructor(
    private router: Router,
    private parameter: ParameterService,
    private building: BuildingService,
    private floor: FloorService
  ) {
    this.dataMap = '';
    this.minDate = new Date();
    this.dataSource = new MatTableDataSource();

    this.generateAvailableHours();
    this.updateAvailableMinutes();
    this.buildForm();
    this.disabledFormDate = true;
  }
  searchTerm = '';

  PullHours() {
    this.generateAvailableHours();
  }

  get buildingId() {
    return this.formCreated.get('buildingId')?.value;
  }

  get floorID() {
    return this.formCreated.get('selectfloor')?.value;
  }

  get selectWorker() {
    return this.formCreated.get('selectWorker')?.value;
  }

  ngOnInit() {
    // Restriccion para solo fecha actual
    const businessId = this.bussinesService.getBussinesId();
    this.ahora = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate()
    );

    this.selectedMinute = 0;
    // Obtener la hora actual en formato "HH:mm"
    const now = new Date();
    const horaActual = `${this.padZero(now.getHours())}:${this.padZero(
      now.getMinutes()
    )}`;
    // Filtrar los horarios mayores a la hora actual
    this.horariosFiltrados = this.horarios.filter(
      horario => horario > horaActual
    );
    this.ObtenerDuracion();
    this.ObtenerEdificios();
    this.PullHours();
    if (businessId) {
      this.loadworker(businessId);
    }
  }

  ngAfterViewInit(): void {
    this.loadMap();
    this.clearCanvas();
  }

  ObtenerEdificios() {
    this.building.getBuildings().subscribe(response => {
      if (response.status) {
        this.edificios = response.reply;
      } else {
        console.error('Error al obtener los los edificios:', response.detail);
      }
    });
  }

  selectType(type: number): void {
    this.typeId.set(type);
  }

  selectFloor(floor: number): void {
    this.floorId.set(floor);
    console.log(this.floorId());
  }

  formatDate(): void {
    if (this.selectedDate) {
      const format = customFormatDate(this.selectedDate);
      const noFormat = customNoFormatDate(this.selectedDate);

      this.noFormatDate.set(this.fullData(noFormat));
      this.startDate.set(this.fullData(format));

      this.PullHours();
      this.updateAvailableMinutes();
    }
  }

  searchWorkPlace() {
    if (this.formCreated.valid) {
      this.workplaces = false;
      this.formatDate();
      const initialDate = new Date(this.noFormatDate());
      const durationNumber = this.duration.match(/\d+/);
      const number = parseInt(durationNumber![0], 10);
      initialDate.setHours(initialDate.getHours() + number);
      this.endDate.set(customFullDate(initialDate));

      this.workplaceService
        .availablePositions(
          this.formCreated.get('selectWorker')?.value,
          this.floorId(),
          this.startDate(),
          this.endDate(),
          this.typeId()
        )
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(({ reply, code, reason }) => {
          if (code === 10000) {
            const data: any = reply;
            this.available.set(reply);
            if (data.available !== -1) {
              this.workplaces = true;
              this.loadMap();
            } else {
              this.workplaces = false;
              this.alertService.error('No se encontraron puestos disponibles.');
            }
          } else {
            this.alertService.error(reason);
          }
        });
    }
  }

  workers: User[] = [];

  loadworker(businessId: string) {
    this.reservationsService
      .getAllUser(businessId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.workers = resp.reply || [];
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
  }

  floors: Floor[] = [];

  chargueFloorByBuilding(buldingid: number) {
    this.floors = [];
    this.floor
      .getFloorsByBuilding(buldingid)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.floors = resp.reply || [];
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
  }

  chargueWorkPLaceType() {
    this.puestos = [];
    this.#workPLaceTypeService
      .postWorkPlaceTypeAvailable(
        this.buildingId,
        this.floorID,
        this.selectWorker
      )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.puestos = resp.reply || [];
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
  }

  selectbuilding: any;

  private MaxHours: number = -1;
  reservationDuration: any[] = [];
  private Parameters: Parameter[] = [];
  ObtenerDuracion() {
    const businessId = this.bussinesService.getBussinesId();
    console.log('businessId', businessId);
    this.parameter
      .getParameter('MaxHorasReserva', parseInt(businessId!))
      .subscribe({
        next: (required: any) => {
          this.Parameters = required.reply;
          if (required.code === 10000) {
            this.Parameters = required.reply;
            //Codigo ionic
            const tmp: number = parseInt(this.Parameters[0].value);
            for (let i = 0; i < tmp; i++) {
              const element: string = i + 1 + ' hr';
              this.reservationDuration.push(element);
            }
          } else {
            this.alertService.error(required.detail);
          }
        },
      });
  }

  private fullData(data: string): string {
    if (this.selectedMinute.toString().length <= 1) {
      return `${data} ${this.selectedHour}:${'0' + this.selectedMinute}:00`;
    } else {
      return `${data} ${this.selectedHour}:${this.selectedMinute}:00`;
    }
  }

  async generateAvailableHours() {
    const hours: any = [];

    const DateNow = new Date();
    const day = DateNow.getDate().toString().padStart(2, '0');
    const month = (DateNow.getMonth() + 1).toString().padStart(2, '0');
    const year = DateNow.getFullYear();

    let HoraInicial: number = 0;
    let HoraFinal: number = 0;
    const businessId = this.bussinesService.getBussinesId();
    
    this.parameter
      .getParameter('horaInicio', parseInt(businessId!))
      .subscribe({
        next: (required: any) => {
          HoraInicial = parseInt(required.reply[0].value);
          
          this.parameter
            .getParameter('horaFinal', parseInt(businessId!))
            .subscribe({
              next: (resp: any) => {
                HoraFinal = parseInt(resp.reply[0].value);
                
                const formattedDate = `${day}-${month}-${year}`;
                if (this.selectedDate != null) {
                  const startdate = customFormatDate(this.selectedDate);

                  if (formattedDate == startdate) {
                    let currentHour = new Date().getHours();
                    if (HoraInicial > currentHour) {
                      currentHour = HoraInicial;
                    }

                    for (let i = currentHour; i <= HoraFinal; i++) {
                      let hora = i.toString();
                      if (hora.length <= 1) {
                        hora = '0' + hora;
                        hours.push(hora);
                      } else {
                        hours.push(hora);
                      }
                    }
                    this.availableHours.set(hours);
                  } else {
                    const currentHour = HoraInicial;
                    for (let i = currentHour; i <= HoraFinal; i++) {
                      let hora = i.toString();
                      if (hora.length <= 1) {
                        hora = '0' + hora;
                        hours.push(hora);
                      } else {
                        hours.push(hora);
                      }
                    }
                    this.availableHours.set(hours);
                  }
                } else {
                  // Caso cuando no hay fecha seleccionada (primera carga)
                  let currentHour = new Date().getHours();
                  if (HoraInicial > currentHour) {
                    currentHour = HoraInicial;
                  }

                  for (let i = currentHour; i <= HoraFinal; i++) {
                    let hora = i.toString();
                    if (hora.length <= 1) {
                      hora = '0' + hora;
                      hours.push(hora);
                    } else {
                      hours.push(hora);
                    }
                  }
                  this.availableHours.set(hours);
                }
              },
            });
        },
      });
  }

  updateAvailableMinutes() {
    this.availableMinutes = [];
    const currentMinute = new Date().getMinutes();
    let currentHour = new Date().getHours().toString();

    const DateNow = new Date();
    const formattedDate = customFormatDate(DateNow);
    if (currentHour.toString().length <= 1) {
      currentHour = '0' + currentHour;
    }

    if (
      this.selectedHour.toString() === currentHour &&
      this.selectedDate != null
    ) {
      const startdate = customFormatDate(this.selectedDate);
      // Si la hora seleccionada es la hora actual, solo permitir minutos futuros.
      if (formattedDate == startdate) {
        for (
          let i = currentMinute + 15 - (currentMinute % 15);
          i < 60;
          i += 15
        ) {
          this.availableMinutes.push(i);
        }
      } else {
        for (let i = 0; i < 60; i += 15) {
          this.availableMinutes.push(i);
        }
      }
    } else {
      // Si la hora seleccionada es una hora futura, permitir todos los minutos.
      for (let i = 0; i < 60; i += 15) {
        this.availableMinutes.push(i);
      }
    }
  }

  // Función para agregar un cero delante de un número si es necesario
  padZero(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  hideRequiredControl = new FormControl(false);

  private buildForm() {
    this.formCreated = this.formBuilder.group({
      startDate: ['', Validators.required],
      hours: ['', Validators.required],
      minute: ['', Validators.required],
      selectworkplacetype: ['', Validators.required],
      selectDuration: ['', Validators.required],
      buildingId: ['', Validators.required],
      selectfloor: ['', Validators.required],
      selectWorker: ['', Validators.required],
      selectPuesto: [''],
    });
  }

  onSubmit() {
    const type = this.isActiveSearch ? 'random' : 'normal';
    if (type == 'random') {
      this.formatDate();
      const initialDate = new Date(this.noFormatDate());
      const durationNumber = this.duration.match(/\d+/);
      const number = parseInt(durationNumber![0], 10);
      initialDate.setHours(initialDate.getHours() + number);
      this.endDate.set(customFullDate(initialDate));
      this.body = {
        type,
        startdate: this.startDate(),
        enddate: this.endDate(),
        workplaceid: 0,
        workplacetype: this.formCreated.get('selectworkplacetype')?.value,
        floorId: this.formCreated.get('selectfloor')?.value,
        worker: this.formCreated.get('selectWorker')?.value,
      };
      this.workplaces = false;
      this.available.set([]);
    } else {
      this.body = {
        type,
        startdate: this.startDate(),
        enddate: this.endDate(),
        workplaceid: this.formCreated.get('selectPuesto')?.value,
        worker: this.formCreated.get('selectWorker')?.value,
      };
      this.workplaces = false;
      this.available.set([]);
    }

    // Cuando es random enviar mismo mas floorid y typeid
    this.reservationsService
      .postReservation(this.body)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: ({ code, detail }) => {
          if (code === 10000) {
            this.buildForm();
            this.alertService.sucess('Reserva creada exitosamente');
          } else {
            this.alertService.error(detail);
          }
        },
        error: error => this.alertService.error(error),
      });
  }

  findReserv() {
    if (this.formCreated.valid) {
      this.disabledFormDate = false;
      this.buildForm();
      this.router.navigate(['/admin/reservations/detail-page']);
    }
  }

  // Edificio
  private buildings() {
    this.buildingService
      .getBuildings()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.groups = resp.reply;
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
  }

  chargueBuildings(id: number) {
    this.buildingService
      .getBuilding(id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.dataSource = new MatTableDataSource(resp.reply.workPlaceGroup);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
  }

  clearForm() {
    this.buildForm();
  }

  //*MAPA

  loadMap() {
    this.isLoading = true;
    this.floorService.getFloorMap(this.floorId().toString()).subscribe({
      next: request => {
        if (request.code === 10000) {
          this.dataMap = request.reply[0].map || [];
          console.log(this.dataMap);
        }
      },
      complete: () => {
        this.isLoading = false;
        this.createImg(); // Llama a la función createImg después de que la imagen se haya cargado
      },
    });
  }
  image = new Image(); // Crea una nueva instancia de la clase Image
  createImg() {
    this.image.src = this.dataMap; // Establece la fuente de la imagen en la URL proporcionada
    const ctx: CanvasRenderingContext2D =
      this.canvas.nativeElement.getContext('2d'); // Obtiene el contexto 2D del elemento canvas
    // Cuando la imagen se carga correctamente, se ejecuta  función de devolución de llamada
    this.image.onload = () => {
      const imageWidth = this.image.width;
      const imageHeight = this.image.height;
      // Borra el contenido del canvas actual
      this.clearCanvas();
      ctx.drawImage(
        this.image,
        0,
        0,
        (this.canvas.nativeElement.width = this.image.width), //asignar tamano del canvas con el de la imagen
        (this.canvas.nativeElement.height = this.image.height)
      );
      //*Funcion que dibuja un circulos DESCOMENTE
      this.drawCircles(imageWidth, imageHeight);
    };
  }

  clearCanvas() {
    const ctx: CanvasRenderingContext2D =
      this.canvas.nativeElement.getContext('2d');
    ctx.clearRect(
      0,
      0,
      this.canvas.nativeElement.width,
      this.canvas.nativeElement.height
    );
  }

  //* Función para dibujar los círculos
  async drawCircles(imageWidth: number, imageHeight: number) {
    const ctx: CanvasRenderingContext2D =
      this.canvas.nativeElement.getContext('2d');
    //* Llamar a la función para obtener y dibujar las coordenadas
    // console.log('Datos para dibujar', this.data);
    this.getCoordinates(this.floorId(), ctx, imageWidth, imageHeight);
  }

  //*Funcion para obtener las cordenadas x,y y dibuja el circulo
  async getCoordinates(
    id: number,
    ctx: CanvasRenderingContext2D,
    newImageWidth: number,
    newImageHeight: number
  ) {
    this.workplaceService
      .availablePositions(
        this.formCreated.get('selectWorker')?.value,
        this.floorId(),
        this.startDate(),
        this.endDate(),
        this.typeId()
      )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (
            resp.reply !== null &&
            typeof resp.reply === 'object' &&
            'available' in resp.reply
          ) {
            const availablePositions = resp.reply.available;
            const workplaceData = availablePositions as BusyWorkplace[];
            // Obtener las dimensiones del nuevo nivel (nueva imagen)
            const canvasWidth = this.canvas.nativeElement.width;
            const canvasHeight = this.canvas.nativeElement.height;
            workplaceData.forEach(point => {
              const { x, y, name } = point;
              // Ajustar las coordenadas en función del tamaño original de la imagen
              const adjustedX = (x / newImageWidth) * canvasWidth;
              const adjustedY = (y / newImageHeight) * canvasHeight;
              // Calcular el radio escalable
              const radius = this.calculateScaledRadius(
                point,
                canvasWidth,
                canvasHeight,
                newImageWidth,
                newImageHeight
              );
              // Llama a la función drawCircle con las coordenadas y los radios ajustados
              this.drawCircle(ctx, adjustedX, adjustedY, radius, 'green', 0.5);
              //Array que me guarda las cordenadas
              const coordenadas: Coordinates = {
                adjustedX: adjustedX,
                adjustedY: adjustedY,
              };
              this.co.push(coordenadas);
            });
          }
        },
      });
  }

  calculateScaledRadius(
    point: BusyWorkplace,
    canvasWidth: number,
    canvasHeight: number,
    newImageWidth: number,
    newImageHeight: number
  ): number {
    // Calcula un radio escalable en función de las dimensiones de la imagen
    const scaleFactor = 0.035; // Factor de escala (ajusta de radio) - Aumentado para puntos más grandes
    const radiusX = newImageWidth * scaleFactor * (canvasWidth / newImageWidth);
    const radiusY =
      newImageHeight * scaleFactor * (canvasHeight / newImageHeight);
    return radiusX;
  }
  async drawCircle(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    radius: number,
    color: string,
    opacity: number
  ) {
    ctx.beginPath();
    ctx.arc(x, y, radius, 0, 2 * Math.PI);
    ctx.fillStyle = color;
    ctx.globalAlpha = opacity;
    ctx.fill();
    ctx.closePath();
    ctx.globalAlpha = 1; // Restablece la opacidad a su valor predeterminado
  }

  //CODIGO PARA SABER CUANTOS DONDE ESTA
  dataInfo!: Workplace;

  isInsideAnyCircle(
    x: number,
    y: number,
    canvasWidth: number,
    canvasHeight: number
  ): boolean {
    // Itera sobre el array this.workplace y verifica si el clic está dentro de algún círculo
    for (const punto of this.available().available) {
      const radio = this.calculateScaledRadius(
        punto,
        canvasWidth,
        canvasHeight,
        this.image.width,
        this.image.height
      );
      console.log('x', x);
      console.log('y', y);
      console.log('radio', radio);
      const distancia = Math.sqrt((x - punto.x) ** 2 + (y - punto.y) ** 2);
      console.log('distancia', distancia);
      if (distancia < radio) {
        this.dataInfo = punto;
        return true;
      }
    }
    return false;
  }
  canvasDblClickk(event: MouseEvent) {
    // Obtener las dimensiones del nuevo nivel (nueva imagen)
    const canvasWidth = this.canvas.nativeElement.width;
    const canvasHeight = this.canvas.nativeElement.height;
    const x = event.offsetX;
    const y = event.offsetY;

    // Ajustar las coordenadas en función del tamaño original de la imagen
    const adjustedX = (x / this.image.width) * canvasWidth;
    const adjustedY = (y / this.image.height) * canvasHeight;

    // Verifica si las coordenadas (x, y) están dentro de los límites de la imagen
    if (x >= 0 && x <= this.image.width && y >= 0 && y <= this.image.height) {
      const isInsideCircle = this.isInsideAnyCircle(
        x,
        y,
        canvasWidth,
        canvasHeight
      );
      // Verifica si las coordenadas (x, y) no están en el array de coordenadas co

      const circleIndex = this.getCircleIndex(adjustedX, adjustedY);
      console.log('isInsideCircle', isInsideCircle);
      console.log('circleIndex', circleIndex);

      if (circleIndex !== -1) {
        // Si se hace clic en un círculo, abre el modal de información del círculo
        console.log(this.dataInfo);
        if (this.dataInfo) {
          this.formCreated
            .get('selectPuesto')
            ?.setValue(this.dataInfo.workplace_id);
        }
      } else {
        // Si no se hace clic en un círculo, abre el modal general
        console.log('circle', circleIndex);
      }
    }
  }
  getCircleIndex(x: number, y: number): number {
    for (let i = 0; i < this.co.length; i++) {
      const coordinate = this.co[i];
      const radius = this.calculateScaledRadius(
        this.available().available[i],
        this.canvas.nativeElement.width,
        this.canvas.nativeElement.height,
        this.image.width,
        this.image.height
      );
      const distance = Math.sqrt(
        (coordinate.adjustedX - x) ** 2 + (coordinate.adjustedY - y) ** 2
      );

      // Verifica si el clic está dentro del círculo
      if (distance <= radius) {
        return i; // Devuelve el índice cuando se encuentra la coincidencia
      }
    }

    return -1; // Retorna -1 si no se encuentra ninguna coincidencia
  }
}
